export enum DataType {
    // Primitive types
    BOOL = "bool",
    FLOAT = "float",
    INT = "int",
    STRING = "string",

    // Date/Time types
    DATE = "date",
    DATERANGE = "daterange",
    DATETIME = "datetime",
    TIME = "time",

    // Currency
    CURRENCY = "currency",

    // 'Number with Unit' types
    DISTANCE_WU = "distance_wu",
    LENGTH_WU = "length_wu",
    TEMPERATURE_WU = "temperature_wu",
    VOLUME_WU = "volume_wu",
    WEIGHT_WU = "weight_wu",

    // Misc Collection types
    LIST = "list",
    OBJECT = "object"
}
